import React, { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import './Table.css'
import PulseLoader from 'react-spinners/PulseLoader'
import SyncLoader from 'react-spinners/SyncLoader'
import { Table as Tableantd } from 'antd'
import { CSVLink } from 'react-csv'
import userContext from '../../context/user-context'
import ccode_branchmap from '../../data/pg-seats.json'
import sub_keymap from '../../data/subkey_map.json'
import { unparse as PapaUnparse } from 'papaparse'
import pgmapdata from '../../data/pgmaps.json'
const XLSX = require('xlsx')

export const Table = () => {
  const navigate = useNavigate()

  const { clgcode } = useContext(userContext)
  const [tabledata, setTabledata] = useState([])
  const [exceldownloaddata, setExceldownloaddata] = useState([])
  const [bcode, setbcode] = useState('')
  const [isloading, setIsloading] = useState(false)
  const [downloadinflag, setDownloadinflag] = useState(false)
  const [isdatafetched, setIsdatafetched] = useState(false)
  const [branchwise_count, setBranchwise_count] = useState(0)
  const [loading2, setLoading2] = useState(false)
  // const URL = "http://localhost:8080";
  const URL = 'https://collegeportal.tngasa.in'

  console.log(clgcode)

  const options2 = ccode_branchmap.filter(data => {
    return data.colCode == clgcode
  })

	const DIFF_ABLED_TYPES = [
		{ key: "1", label: "Blindness" },
		{ key: "2", label: "Low-vision" },
		{ key: "3", label: "Leprosy Cured persons" },
		{ key: "4", label: "Hearing Impairment (deaf and hard of hearing)" },
		{ key: "5", label: "Locomotor Disability" },
		{ key: "6", label: "Acid Attack Victim" },
		{ key: "7", label: "Dwarfism" },
		{ key: "8", label: "Intellectual Disability" },
		{ key: "9", label: "Mental Illness" },
		{ key: "10", label: "Autism Spectrum Disorder" },
		{ key: "11", label: "Cerebral Palsy" },
		{ key: "12", label: "Muscular Dystrophy" },
		{ key: "13", label: "Chronic Neurological Conditions" },
		{ key: "14", label: "Specific Learning Disabilities" },
		{ key: "15", label: "Multiple Sclerosis" },
		{ key: "16", label: "Speech and Language disability" },
		{ key: "17", label: "Thalassemia" },
		{ key: "18", label: "Hemophilia" },
		{ key: "19", label: "Sickle Cell Disease" },
		{ key: "20", label: "Multiple Disabilities including deaf blindness" },
		{ key: "21", label: "Parkinson's disease" }
	];

  const SPORTS_LEVEL_OF_PARTICIPATION = [
    { key: '1', label: 'District' },
    { key: '2', label: 'Divisional' },
    { key: '3', label: 'State' },
    { key: '4', label: 'National' },
    { key: '5', label: 'International' },
    { key: '6', label: 'None of the above' }
  ]

  const SECURITY_FORCES_OPTS = [
    { key: '1', label: 'Widows/wards of Defense personnel killed in action' },
    {
      key: '2',
      label: 'Wards of serving personnel and ex-servicemen disabled in action'
    },
    {
      key: '3',
      label:
        'Widows/Wards of Defense personnel who died in peace time with death attributable to Military service.'
    },
    {
      key: '4',
      label:
        'Wards of Defense personnel disabled in peace time with disability attributable to military service'
    },
    {
      key: '5',
      label:
        'Wards of Ex-servicemen personnel and serving police forces who are in receipt of Gallantry Awards (Gallaniry Awards include : Paramvir Chakra, Ashok Chakra, SarvottamYudhSeva Medal, MahaVir Chakra, Kirti Chakra, UitamYudhseva Medal, Vir Chakra, Shaurya Chakra, Yudhseva Medal Sena,  Nausena-Vayusena Medal.)'
    },
    {
      key: '6',
      label: "President Police Medal for Gallantry' Police medal for Gallantry"
    },
    { key: '7', label: 'None of the Above' }
  ]

  const dimention_changer = list => {
    console.log(list)
    const temp = removeDuplicates(list, '_aid')
    console.log(temp)
    temp.map(data => {
      var choices = ''
      list.map(data2 => {
        if (data._aid === data2._aid) {
          choices = choices + ' ' + data2.bcode
          console.log(data._aid)
        }
      })
      data['choice_list'] = choices
      return data
    })

    console.log(temp)

    return temp
  }

  const diffid_to_name = id => {
    // console.log(id);
    const type = DIFF_ABLED_TYPES.find(data => data.key === id)
    if (type) {
      return type?.label
    } else {
      return ''
    }
  }

  const sportid_to_name = id => {
    const type = SPORTS_LEVEL_OF_PARTICIPATION.find(data => data.key === id)
    return type.label
  }

  const security_forces_to_name = id => {
    const type = SECURITY_FORCES_OPTS.find(data => data.key === id)
    return type.label
  }

  const pgbranch_to_name = id => {
    const type = pgmapdata.branch.find(data => data.brCode === parseInt(id))
    if (type == undefined) {
      return id.toString()
    } else {
      return type.BrStudy
    }
  }

  const pgUniver_to_name = id => {
    const type = pgmapdata.univ.find(data => data.UniCode === parseInt(id))
    if (type == undefined) {
      return id.toString()
    } else {
      return type.uniName
    }
  }

  const pgdegree_to_name = id => {
    const type = pgmapdata.Degree.find(data => data.DegCode === parseInt(id))
    if (type == undefined) {
      return id.toString()
    } else {
      return type.degName
    }
  }

  const options = [
    { value: 'ATTE1', label: 'ATTE1' },
    { value: 'APAE1', label: 'APAE1' },
    { value: 'SPHE1', label: 'SPHE1' }
  ]

  const isadvanced = data => {
    var flag = false
    if (
      data.s1 == '2' ||
      data.s2 == '2' ||
      data.s3 == '2' ||
      data.s4 == '2' ||
      data.s5 == '2' ||
      data.s6 == '2'
    ) {
      flag = true
    }

    if (data.s6 !== undefined || data.s6 !== null) {
      if (data.s6 == '2') {
        flag = true
      }
    }

    return flag
  }

  const istamilstudied = data => {
    var flag = false
    if (
      data.s1 == '73' ||
      data.s2 == '73' ||
      data.s3 == '73' ||
      data.s4 == '73' ||
      data.s5 == '73' ||
      data.s6 == '73'
    ) {
      flag = true
    }

    if (data.s6 !== undefined || data.s6 !== null) {
      if (data.s6 == '74') {
        flag = true
      }
    }

    return flag
  }

  const r1list = [
    'LTLT1',
    'LTLT2',
    'LTAT1',
    'LTAT2',
    'LMAE1',
    'LTET1',
    'LTET2',
    'LURE1',
    'LHDE1',
    'LSAE1'
  ]

  const r2list = ['LENE1', 'LENE1M', 'LENE2']

  const tamil_list = ['LTLT1', 'LTLT2', 'LTAT1', 'LTAT2']

  const isr1 = value => {
    if (r1list.includes(value)) {
      return true
    } else {
      return false
    }
  }

  const isr2 = value => {
    if (r2list.includes(value)) {
      return true
    } else {
      return false
    }
  }

  const isr3 = value => {
    if (!r1list.includes(value) && !r2list.includes(value)) {
      return true
    } else {
      return false
    }
  }

  const istamilbranch = value => {
    if (tamil_list.includes(value)) {
      return true
    } else {
      return false
    }
  }

  const sub_to_name = sub_code => {
    // console.log()

    var subname = sub_keymap.find(
      data => data.s_no.toString() == sub_code
    ).sub_name

    return subname
  }

  const sub_to_name2 = sub_code => {
    // console.log()

    var subname = sub_keymap.find(data => data.s_no.toString() == sub_code)

    if (subname === null || subname === undefined) {
      console.log(sub_code)
      return 'No data'
    }

    return subname.sub_name
  }

  const hg_to_data = hg => {
    if (hg == null || hg == 1) {
      return 'Academic'
    } else {
      return 'Vocational'
    }
  }

  const subs_to_data = record => {
    var subsstudied = ''
    if (record.s1 !== undefined && record.s1 !== null) {
      subsstudied = subsstudied + '1.' + sub_to_name2(record.s1) + '\t'
    }
    if (record.s2 !== undefined && record.s2 !== null) {
      subsstudied = subsstudied + '2.' + sub_to_name2(record.s2) + '\t'
    }
    if (record.s3 !== undefined && record.s3 !== null) {
      subsstudied = subsstudied + '3.' + sub_to_name(record.s3) + '\t'
    }
    if (record.s4 !== undefined && record.s4 !== null) {
      subsstudied = subsstudied + '4.' + sub_to_name2(record.s4) + '\t'
    }
    if (record.s5 !== undefined && record.s5 !== null) {
      subsstudied = subsstudied + '5.' + sub_to_name2(record.s5) + '\t'
    }
    if (record.s6 !== undefined && record.s6 !== null) {
      subsstudied = subsstudied + '6.' + sub_to_name2(record.s6) + '\t'
    }

    return subsstudied
  }

  function removeDuplicates (array, key) {
    const seen = new Set()
    return array.filter(obj => {
      const keyValue = obj[key]
      if (seen.has(keyValue)) {
        return false
      }
      seen.add(keyValue)
      return true
    })
  }

  const exdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/ex?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const sorteddata = dimention_changer(data.result)

        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          // category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,
          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
          DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
        });
        
        console.log(csvData)

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, 'Exservice.xlsx')
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const nccdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/ncc?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const sorteddata = dimention_changer(data.result)

        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          // category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,

          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
           DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
				});

        console.log(csvData)

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, 'Ncc.xlsx')
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const antsdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/ants?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)
        const dimention = dimention_changer(data.result)

        var sorteddata = dimention.sort((a, b) => {
          return parseFloat(a.r3) - parseFloat(b.r3)
        })
        // Convert the fetched data to CSV format
        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          Stream: hg_to_data(item.hg),
          Subjects_Studied: subs_to_data(item),
          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Branch_choice: item.choice_list,
          DPI_Matched:
            item.df === null || item.df === undefined
              ? 'To Be Verified'
              : item.df,
          Aggregate_marks: item.rks3
        }))

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        const csvDataString = PapaUnparse(csvData)
        const csvBlob = new Blob([csvDataString], {
          type: 'text/csv'
        })
        const csvUrl = URL.createObjectURL(csvBlob)
        const link = document.createElement('a')
        link.href = csvUrl
        link.download = `${clgcode}_andaman&nicobar.csv`
        link.click()
        URL.revokeObjectURL(csvUrl)
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const sportsdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/sports?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const sorteddata = dimention_changer(data.result)

        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          // category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          category: sportid_to_name(item.slp),
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,
          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
           DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
				});

        console.log(csvData)

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, 'Sports.xlsx')
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const dapdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/dap?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)
        const temp = dimention_changer(data.result)

        // Convert the fetched data to CSV format
        const csvData = temp.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,

          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
           DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
				});

        console.log(csvData)

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, 'Disabled.xlsx')
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const securityforcesdownload = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/secforce?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)
        const sorteddata = dimention_changer(data.result)

        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          // category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          category: security_forces_to_name(item.psf),
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,
          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
          DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
				});

        console.log(csvData)

        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, 'SecurityForces.xlsx')
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const part1download = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/part?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const newdata = removeDuplicates(data.result, '_aid')

        var advtamilstudents = newdata.filter(data => isadvanced(data))

        var nontamilsadvtudets = newdata.filter(data => {
          if (isadvanced(data)) {
            return false
          } else {
            return true
          }
        })

        var onlytamil = nontamilsadvtudets.filter(data => istamilstudied(data))
        var notamilatall = nontamilsadvtudets.filter(data => {
          if (istamilstudied(data)) {
            return false
          } else {
            return true
          }
        })

        var wholetamillist = []

        var advtamilstudentssorted = advtamilstudents.sort((a, b) => {
          return parseFloat(a.r1) - parseFloat(b.r1)
        })

        var onlytamilsorted = onlytamil.sort((a, b) => {
          return parseFloat(a.r1) - parseFloat(b.r1)
        })

        var notamilatallsorted = notamilatall.sort((a, b) => {
          return parseFloat(a.r1) - parseFloat(b.r1)
        })

        var temp = wholetamillist.concat(advtamilstudentssorted)
        var temp1 = temp.concat(onlytamilsorted)
        var temp2 = temp1.concat(notamilatallsorted)

        var sorteddata = temp2

        console.log(sorteddata)

        sorteddata.map((value, index) => {
          value['rank'] = index + 1
        })
        // Convert the fetched data to CSV format
        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          rank: item.rank,
          Admission_No: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          Stream: hg_to_data(item.hg),
          Subjects_Studied: subs_to_data(item),
          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Aggregate_marks: item.rks1,
          DPI_Matched:
            item.df === null || item.df === undefined
              ? 'To Be Verified'
              : item.df
        }))

        // Trigger the CSV download
        const csvDataString = PapaUnparse(csvData)
        const csvBlob = new Blob([csvDataString], {
          type: 'text/csv'
        })
        const csvUrl = URL.createObjectURL(csvBlob)
        const link = document.createElement('a')
        link.href = csvUrl
        link.download = `${clgcode}_part1.csv`
        link.click()
        URL.revokeObjectURL(csvUrl)
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const part2download = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/part?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const newdata = removeDuplicates(data.result, '_aid')

        var sorteddata = newdata.sort((a, b) => {
          return parseFloat(a.r2) - parseFloat(b.r2)
        })

        sorteddata.map((value, index) => {
          value['rank'] = index + 1
        })
        // Convert the fetched data to CSV format
        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          rank: item.rank,
          Admission_No: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          Stream: hg_to_data(item.hg),
          Subjects_Studied: subs_to_data(item),
          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Aggregate_marks: item.rks2,
          DPI_Matched:
            item.df === null || item.df === undefined
              ? 'To Be Verified'
              : item.df
        }))

        // Trigger the CSV download
        const csvDataString = PapaUnparse(csvData)
        const csvBlob = new Blob([csvDataString], {
          type: 'text/csv'
        })
        const csvUrl = URL.createObjectURL(csvBlob)
        const link = document.createElement('a')
        link.href = csvUrl
        link.download = `${clgcode}_part2.csv`
        link.click()
        URL.revokeObjectURL(csvUrl)
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const part3download = async () => {
    // Perform the fetch call to get the array of objects
    fetch(`${URL}/api/part?clgid=${clgcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)

        const newdata = removeDuplicates(data.result, '_aid')

        var sorteddata = newdata.sort((a, b) => {
          return parseFloat(a.r3) - parseFloat(b.r3)
        })

        sorteddata.map((value, index) => {
          value['rank'] = index + 1
        })
        // Convert the fetched data to CSV format
        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns

          rank: item.rank,
          Admission_No: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          Stream: hg_to_data(item.hg),
          Subjects_Studied: subs_to_data(item),
          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Aggregate_marks: item.tot,
          DPI_Matched:
            item.df === null || item.df === undefined
              ? 'To Be Verified'
              : item.df
        }))

        // Trigger the CSV download
        const csvDataString = PapaUnparse(csvData)
        const csvBlob = new Blob([csvDataString], {
          type: 'text/csv'
        })
        const csvUrl = URL.createObjectURL(csvBlob)
        const link = document.createElement('a')
        link.href = csvUrl
        link.download = `${clgcode}_part3.csv`
        link.click()
        URL.revokeObjectURL(csvUrl)
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  const columns = [
    { title: 'Rank', dataIndex: 'rank', key: '12' }, // 	key: "1" // 	dataIndex: "ogrank", // 	title: "OgRank", // {
    // },
    { title: 'RegNo', dataIndex: '_aid', key: '2' },
    { title: 'Name', dataIndex: 'name', key: '25' },
    { title: 'Email', dataIndex: 'e', key: '3' },
    { title: 'Gender', dataIndex: 'g', key: '4' },
    { title: 'Community', dataIndex: 'comm', key: '5' },
    {
      title: 'Stream',
      render: (id, record, index) => {
        if (record.hg == null || record.hg == 1) {
          return 'Academic'
        } else {
          return 'Vocational'
        }
      },
      key: '6'
    },
    { title: 'Aggregate Mark', dataIndex: 'agg', key: '7' },
    {
      title: 'Sub Stud',
      render: (id, record, index) => {
        var subsstudied = ''
        if (record.s1 !== undefined && record.s1 !== null) {
          subsstudied = subsstudied + '1.' + sub_to_name(record.s1) + '\t'
        }
        if (record.s2 !== undefined && record.s2 !== null) {
          subsstudied = subsstudied + '2.' + sub_to_name(record.s2) + '\t'
        }
        if (record.s3 !== undefined && record.s3 !== null) {
          subsstudied = subsstudied + '3.' + sub_to_name(record.s3) + '\t'
        }
        if (record.s4 !== undefined && record.s4 !== null) {
          subsstudied = subsstudied + '4.' + sub_to_name(record.s4) + '\t'
        }
        if (record.s5 !== undefined && record.s5 !== null) {
          subsstudied = subsstudied + '5.' + sub_to_name(record.s5) + '\t'
        }
        if (record.s6 !== undefined && record.s6 !== null) {
          subsstudied = subsstudied + '6.' + sub_to_name(record.s6) + '\t'
        }

        return subsstudied
      },
      key: '8'
    },
    { title: 'Choice No', dataIndex: 'cno', key: '26' },
    { title: 'Mobile', dataIndex: 'm', key: '9' },
    { title: 'Alt Mobile', dataIndex: 'alm', key: '10' }
  ]

  const getdata = () => {
    setDownloadinflag(true)
    console.log(clgcode, bcode)
    fetch(`${URL}/api/list/maker?clgid=${clgcode}&bid=${bcode}`)
      .then(response => response.json())
      .then(data => {
        console.log(data.result)
        const sorteddata = dimention_changer(data.result)

        const csvData = sorteddata.map(item => ({
          // Map the item properties to match your CSV columns
          Application_no: item._aid,
          Name: item.name,
          Gender: item.g,
          Community: item.comm,
          // Stream: hg_to_data(item.hg),
          // Subjects_Studied: subs_to_data(item),
          // category: diffid_to_name(item.adt),

          Mobile: item.m,
          Alt_Mobile: item.alm,
          Email: item.e,
          Branch_choice: item.choice_list,
          // DPI_Matched:
          // 	item.df === null || item.df === undefined
          // 		? "To Be Verified"
          // 		: item.df,
          // Aggregate_marks: item.rks3
          Ug_college_studied: item.colName,
          degree: pgdegree_to_name(item.deg),
          branch_Of_study: pgbranch_to_name(item.brs),
          University_name: pgUniver_to_name(item.univName),
          University_Reg_Number: item.ugReg,
          Month_of_Ug_passing: item.monUG,
          Year_of_UG_passing: item.yrUG,
          semester1_Part1_maxMark: item.sem1part1max,
          semester1_Part1_Obtained: item.sem1part1obt,
          semester1_Part2_maxMark: item.sem1part2max,
          semester1_Part2_Obtained: item.sem1part2obt,
          semester1_Part3_maxMark: item.sem1part3max,
          semester1_Part3_Obtained: item.sem1part3obt,
          semester1_Part4_maxMark: item.sem1part4max,
          semester1_Part4_Obtained: item.sem1part4obt,
          //sem2
          semester2_Part1_maxMark: item.sem2part1max,
          semester2_Part1_Obtained: item.sem2part1obt,
          semester2_Part2_maxMark: item.sem2part2max,
          semester2_Part2_Obtained: item.sem2part2obt,
          semester2_Part3_maxMark: item.sem2part3max,
          semester2_Part3_Obtained: item.sem2part3obt,
          semester2_Part4_maxMark: item.sem2part4max,
          semester2_Part4_Obtained: item.sem2part4obt,
          //sem3
          semester3_Part1_maxMark: item.sem3part1max,
          semester3_Part1_Obtained: item.sem3part1obt,
          semester3_Part2_maxMark: item.sem3part2max,
          semester3_Part2_Obtained: item.sem3part2obt,
          semester3_Part3_maxMark: item.sem3part3max,
          semester3_Part3_Obtained: item.sem3part3obt,
          semester3_Part4_maxMark: item.sem3part4max,
          semester3_Part4_Obtained: item.sem3part4obt,
          //sem4
          semester4_Part1_maxMark: item.sem4part1max,
          semester4_Part1_Obtained: item.sem4part1obt,
          semester4_Part2_maxMark: item.sem4part2max,
          semester4_Part2_Obtained: item.sem4part2obt,
          semester4_Part3_maxMark: item.sem4part3max,
          semester4_Part3_Obtained: item.sem4part3obt,
          semester4_Part4_maxMark: item.sem4part4max,
          semester4_Part4_Obtained: item.sem4part4obt,
          //sem5
          semester5_Part1_maxMark: item.sem5part1max,
          semester5_Part1_Obtained: item.sem5part1obt,
          semester5_Part2_maxMark: item.sem5part2max,
          semester5_Part2_Obtained: item.sem5part2obt,
          semester5_Part3_maxMark: item.sem5part3max,
          semester5_Part3_Obtained: item.sem5part3obt,
          semester5_Part4_maxMark: item.sem5part4max,
          semester5_Part4_Obtained: item.sem5part4obt,
          //sem6
          semester6_Part1_maxMark: item.sem6part1max,
          semester6_Part1_Obtained: item.sem6part1obt,
          semester6_Part2_maxMark: item.sem6part2max,
          semester6_Part2_Obtained: item.sem6part2obt,
          semester6_Part3_maxMark: item.sem6part3max,
          semester6_Part3_Obtained: item.sem6part3obt,
          semester6_Part4_maxMark: item.sem6part4max,
          semester6_Part4_Obtained: item.sem6part4obt,

          //yearwise
          year1_part1_maxMark: item.yr1part1max,
          year1_part1_Obtained: item.yr1part1obt,
          year1_part2_maxMark: item.yr1part2max,
          year1_part2_Obtained: item.yr1part2obt,
          year1_part3_maxMark: item.yr1part3max,
          year1_part3_Obtained: item.yr1part3obt,
          year1_part4_maxMark: item.yr1part4max,
          year1_part4_Obtained: item.yr1part4obt,

          year2_part1_maxMark: item.yr2part1max,
          year2_part1_Obtained: item.yr2part1obt,
          year2_part2_maxMark: item.yr2part2max,
          year2_part2_Obtained: item.yr2part2obt,
          year2_part3_maxMark: item.yr2part3max,
          year2_part3_Obtained: item.yr2part3obt,
          year2_part4_maxMark: item.yr2part4max,
          year2_part4_Obtained: item.yr2part4obt,

          year3_part1_maxMark: item.yr3part1max,
          year3_part1_Obtained: item.yr3part1obt,
          year3_part2_maxMark: item.yr3part2max,
          year3_part2_Obtained: item.yr3part2obt,
          year3_part3_maxMark: item.yr3part3max,
          year3_part3_Obtained: item.yr3part3obt,
          year3_part4_maxMark: item.yr3part4max,
          year3_part4_Obtained: item.yr3part4obt,

          Semester1_CGPA_Max: item.sem1cgpamax,
          Semester1_CGPA_Obtained: item.sem1cgpaobt,

          Semester2_CGPA_Max: item.sem2cgpamax,
          Semester2_CGPA_Obtained: item.sem2cgpaobt,

          Semester3_CGPA_Max: item.sem3cgpamax,
          Semester3_CGPA_Obtained: item.sem3cgpaobt,

          Semester4_CGPA_Max: item.sem4cgpamax,
          Semester4_CGPA_Obtained: item.sem4cgpaobt,

          Semester5_CGPA_Max: item.sem5cgpamax,
          Semester5_CGPA_Obtained: item.sem5cgpaobt,

          Semester6_CGPA_Max: item.sem6cgpamax,
          Semester6_CGPA_Obtained: item.sem6cgpaobt,

          year1_CGPA_Max: item.yr1cgpamax,
          year1_CGPA_Obtained: item.yr1cgpaobt,
          year2_CGPA_Max: item.yr2cgpamax,
          year2_CGPA_Obtained: item.yr2cgpaobt,
          year3_CGPA_Max: item.yr3cgpamax,
          year3_CGPA_Obtained: item.yr3cgpaobt,

          Part1_avg: item.part1Avg,
          Part2_avg: item.part2Avg,
          Part3_avg: parseFloat((!item.part3Avg || item.part3Avg === "0") ? item.cgpaAvg : item.part3Avg),
          Part4_avg: item.part4Avg,
          DOB: item.dob,
          COA: item.coa,
          cracomm: item.cracomm
        }))

        csvData.sort((a, b) => {
          const aAvg = parseFloat(a.Part3_avg)
          const bAvg = parseFloat(b.Part3_avg)

          if (isNaN(aAvg) && isNaN(bAvg)) {
            return 0 // Both are NaN, leave their order unchanged
          } else if (isNaN(aAvg)) {
            return 1 // a is NaN, so b comes before a
          } else if (isNaN(bAvg)) {
            return -1 // b is NaN, so a comes before b
          } else {
            return bAvg - aAvg // Compare as integers for non-NaN values
          }
        })

        csvData.map((value, index) => {
          value["rank"] = index + 1;
          return value
				});

        console.log(csvData)

        // return;
        // const Delremcsvdata = removeDuplicates(csvData, "Admission_No");

        // Trigger the CSV download
        // const csvDataString = PapaUnparse(csvData);
        // const csvBlob = new Blob([csvDataString], { type: "text/csv" });
        // const csvUrl = URL.createObjectURL(csvBlob);
        // const link = document.createElement("a");
        // link.href = csvUrl;
        // link.download = `${clgcode}_disabled.csv`;
        // link.click();
        // URL.revokeObjectURL(csvUrl);

        let binaryWS = XLSX.utils.json_to_sheet(csvData)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')
        XLSX.writeFile(wb, `${bcode}.xlsx`)
        setDownloadinflag(false)
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })
  }

  // const getcount = () => {
  // 	fetch(`${URL}/api/count?clgid=${clgcode}&bid=${bcode}`)
  // 		.then((data) => data.json())
  // 		.then((result) => {
  // 			setBranchwise_count(result.result.count);
  // 			setLoading2(true);
  // 			console.log(result);
  // 		});
  // };

  useEffect(() => {
    if (clgcode == 0) {
      navigate('/')
    }
  }, [])

  return (
    <div className='tablepage'>
      {downloadinflag && (
        <div className='loaderbody'>
          <span className='downllading'>Downloading Document</span>
          <SyncLoader color='indigo' size={20} />
        </div>
      )}

      <div className='tablebody'>
        <div className='tableheader'>
          <div className='tableheaderdata'>Students Data</div>
          <div className='tableheaderunderliner' />
        </div>
        <div className='otherdownloadscont'>
          <p
            style={{
              color: 'red',
              fontSize: '20px'
            }}
          >
            *This is the Provisional Rank list according to the Part-3 Marks as
            entered by respective applicant without considering eligibility
            criteria. The Principals are requested to verify the eligibility and
            data of all candidates before releasing the final rank list.
          </p>
          <div className='otherdownloads'>
            <button
              className='otherdownloadbtnlink'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                setDownloadinflag(true)
                dapdownload()
              }}
            >
              differently abled
            </button>
            <button
              className='otherdownloadbtnlink'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                setDownloadinflag(true)
                sportsdownload()
              }}
            >
              Sports
            </button>
            <button
              className='otherdownloadbtnlink'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                // data={exdownload}
                setDownloadinflag(true)
                exdownload()
              }}
            >
              Ex-service
            </button>
            <button
              className='otherdownloadbtnlink'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                setDownloadinflag(true)
                nccdownload()
              }}
            >
              NCC
            </button>
            <button
              className='otherdownloadbtnlink'
              style={{ textDecoration: 'none' }}
              onClick={() => {
                setDownloadinflag(true)
                securityforcesdownload()
              }}
            >
              Security Forces
            </button>
          </div>
        </div>
        <div className='tableinput'>
          <Select
            placeholder={'Select Branch Name'}
            className='tableselect'
            options={options2}
            onChange={e => {
              setIsdatafetched(false)
              setLoading2(false)
              setbcode(e.value)
            }}
          />
          <button
            style={{ marginLeft: '10px' }}
            onClick={() => {
              getdata()
            }}
          >
            Get Data
          </button>
        </div>
      </div>
    </div>
  )
}
